export default {"src":"/_next/static/media/cape-logo.e14fb3b3.svg","height":73,"width":60,"blurWidth":0,"blurHeight":0};